import {Component, Inject, OnInit} from '@angular/core';
import {DialogModel} from '../../../../core/models';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.css']
})
export class ErrorDialogComponent implements OnInit {

  message: DialogModel;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<ErrorDialogComponent>) { }

  ngOnInit() {
    this.message = this.data;
  }

  close() {
    this.dialogRef.close();
  }

}
